import { all, call, put, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* post(action) {
    const { auditControllers } = action.payload;
    const url = config.api.paths.auditControllers;
    try {
        const data = yield call(http.authorized.post, url, auditControllers);
        yield put(actionCreators.postSuccess(data));
    } catch (error) {
        logToSentry("On audit controllers post:", { error });
        console.error(error);
        yield put(actionCreators.postFailure(error));
    }
}
function* get(action) {
    const { auditControllers } = action.payload;
    const url = `${config.api.paths.auditControllers}`;

    try {
        const { data } = yield call(
            http.authorized.get,

            { audit: id },
            url,
            auditControllers
        );
        yield put(actionCreators.getSuccess(data));
    } catch (error) {
        logToSentry("On audit controllers get:", { error });
        console.error(error);
        yield put(actionCreators.getFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(actionTypes.AUDIT_CONTROLLER_GET_REQUEST, get),
        takeLatest(actionTypes.AUDIT_CONTROLLER_POST_REQUEST, post)
    ]);
}
